import { useQueryClient } from '@tanstack/react-query';
import { useEffect, type ReactNode } from 'react';
import { clearSegmentationOnLogout, subscribeToSegmentationLogout } from '../../helpers/segmentationLogout';

interface Props {
  children: ReactNode;
}

/**
 * Second of two intentional logout cleanups. The logout saga notifies
 * this subscriber in the same synchronous burst as its own cleanup, so the guard
 * limits this call to canceling traits queries.
 */
const SegmentationLogoutCoordinator = ({ children }: Props) => {
  const queryClient = useQueryClient();

  useEffect(() => subscribeToSegmentationLogout(() => {
    clearSegmentationOnLogout(queryClient);
  }), [queryClient]);

  return children;
};

export default SegmentationLogoutCoordinator;
